<template>

    <main class="page-raison-etre">
        <transition v-on:enter="enter" v-on:leave="leave">
            <div class="menu-scroll" v-if="scrolled">
                <div class="menu-scroll-container">
                    <a href="#le-mutualisme-au-coeur-de-notre-ADN" class="menu-scroll-item"
                       :class="{ 'active' : step === 1 }"
                       @click.prevent="goTo($event)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                        <span>
						MUTUALISM LIES <br>
AT THE HEART OF OUR DNA
                </span>
                    </a>
                    <a href="#l-innovation-moteur-de-notre-croissance" class="menu-scroll-item"
                       :class="{ 'active' : step === 2 }"
                       @click.prevent="goTo($event)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                        <span>
                     INNOVATION
IS THE FUEL <br>
THAT POWERS OUR GROWTH

                </span>
                    </a>
                    <a href="#une-forte-presence-en-France-et-dans-le-monde" class="menu-scroll-item"
                       :class="{ 'active' : step === 3 }"
                       @click.prevent="goTo($event)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                        <span>
                     A STRONG PRESENCE <br>
IN FRANCE AND ABROAD

                </span>
                    </a>
                    <a href="#les-instances-de-decision" class="menu-scroll-item" @click.prevent="goTo($event)"
                       :class="{ 'active' : step === 4 }">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                        <span>
                     OUR DECISION-MAKING BODIES
                </span>
                    </a>
                    <a href="#les-indicateurs-rse" class="menu-scroll-item" @click.prevent="goTo($event)"
                       :class="{ 'active' : step === 5 }">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                        <span>
                     OUR CSR INDICATORS
                </span>
                    </a>
                </div>
            </div>
        </transition>

        <div class="container">

            <header class="header">

                <img :src="ww < 600 ? require('../assets/etre-mobile.jpg') : require('../assets/etre.jpg')" alt=""
                     class="header-background">

                <div class="header-list">
                    <a href="#le-mutualisme-au-coeur-de-notre-ADN" class="header-item onscroll onscroll-translate"
                       @click.prevent="goTo($event)">
                <span>
                     	MUTUALISM LIES <br> AT THE HEART OF OUR DNA
                </span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                    </a>
                    <a href="#l-innovation-moteur-de-notre-croissance" class="header-item onscroll onscroll-translate"
                       @click.prevent="goTo($event)">
                <span>
                     INNOVATION
IS THE FUEL <br>
THAT POWERS OUR GROWTH

                </span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                    </a>
                    <a href="#une-forte-presence-en-France-et-dans-le-monde"
                       class="header-item onscroll onscroll-translate"
                       @click.prevent="goTo($event)">
                <span>
                     A STRONG PRESENCE IN FRANCE AND ABROAD

                </span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                    </a>
                    <a href="#les-instances-de-decision" class="header-item onscroll onscroll-translate"
                       @click.prevent="goTo($event)">
                <span>
                    OUR DECISION-MAKING BODIES
                </span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                    </a>

                    <a href="#les-indicateurs-rse" class="header-item onscroll onscroll-translate"
                       @click.prevent="goTo($event)">
                <span>
                     OUR CSR INDICATORS
                </span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.98 95">
                            <polygon points="13.48 0 0 13.48 34.03 47.5 0 81.52 13.48 95 60.98 47.5 13.48 0"/>
                        </svg>
                    </a>


                </div>

            </header>

            <div class="row">
                <div class="col small">
                    <div class="background"></div>
                    <div class="content row-anchor">
                        <div id="le-mutualisme-au-coeur-de-notre-ADN" class="anchor onscroll" data-step="1"></div>
                        <h2 class="onscroll onscroll-title">
                            <span>MUTUALISM LIES</span>
                            <span>AT THE HEART</span>
                            <span>OF OUR DNA</span>
                        </h2>

                        <p class="uppercase bold onscroll onscroll-translate">
                            3 BRANDS TO COVER ALL CUSTOMER NEEDS

                        </p>

                        <div class="client onscroll onscroll-translate">
                            <div class="client-logo">
                                <img src="../assets/logo-groupama.svg" class="groupama" alt="">
                            </div>
                            <div class="client-body">
                                Groupama, the insurer of the real world

                            </div>
                            <a href="https://www.groupama.fr" target="_blank" rel="noreferrer noopener"
                               class="client-link" data-link="www.groupama.fr"><span>www.groupama.fr</span></a>
                        </div>

                        <div class="client onscroll onscroll-translate">
                            <div class="client-logo">
                                <img src="../assets/gan.svg" class="gan" alt="">
                            </div>
                            <div class="client-body">
                                The reference player in the market for entrepreneurs, smes and professionals


                            </div>
                            <a href="https://www.gan.fr" target="_blank" rel="noreferrer noopener" class="client-link"
                               data-link="www.gan.fr"><span>www.gan.fr</span></a>
                        </div>

                        <div class="client onscroll onscroll-translate">
                            <div class="client-logo">
                                <img src="../assets/amaguiz.svg" class="amaguiz" alt="">
                            </div>
                            <div class="client-body">
                                Exclusively dedicated to distance selling of customised products and guarantees.

                            </div>
                            <a href="https://www.amaguiz.com" target="_blank" rel="noreferrer noopener"
                               class="client-link" data-link="www.amaguiz.com"><span>www.amaguiz.com</span></a>
                        </div>
                    </div>
                </div>
                <div class="col large">

                    <h3 class="onscroll onscroll-translate">
                        Our Group today is the legacy of a century-long story that began with the formation of an
                        agricultural mutual insurance movement to protect and serve farmers based on strong values of
                        solidarity, responsibility, commitment, and optimism.
                    </h3>

                    <br><br>

                    <div class="row row-block">
                        <div class="block">
                            <div class="block-image">
                                <img :src="require('../assets/etre-1.svg')" alt="">
                            </div>
                            <div class="block-red">
                                <p>LIFE AND HEALTH INSURANCE</p>
                                <p>
                                <span class="onscroll onscroll-data a" data-index="a" data-fixed="1"
                                      data-end="6.8">0</span>
                                    BILLION IN PREMIUM INCOME

                                </p>
                            </div>
                        </div>
                        <div class="block">
                            <div class="block-image">
                                <img :src="require('../assets/etre-2.svg')" alt="">
                            </div>
                            <div class="block-blue">
                                <p>PROPERTY AND CASUALTY INSURANCE</p>
                                <p>
                                <span class="onscroll onscroll-data b" data-index="b" data-fixed="1"
                                      data-end="7.4">0</span>
                                    BILLION IN PREMIUM INCOME
                                </p>
                            </div>
                        </div>
                        <div class="block">
                            <div class="block-image">
                                <img :src="require('../assets/etre-3.svg')" alt="">
                            </div>
                            <div class="block-yellow">
                                <p>FINANCIAL BUSINESSES</p>
                                <p>
                                <span class="onscroll onscroll-data c" data-index="c" data-fixed="0"
                                      data-end="168">0</span>
                                    MILLION IN PREMIUM INCOME

                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="block">
                            <div class="block-green">
                                <p>
                                <span class="onscroll onscroll-data d" data-index="d" data-fixed="1" data-end="14.4"
                                      data-suffix=" billion">0 billion</span>
                                    IN COMBINED PREMIUM INCOME
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="row">
                <div class="col small">

                    <div class="block-number">
                        <div class="block-number-icon icon-collaborateurs"></div>
                        <p class="block-number-content">
                            <span class="blue onscroll onscroll-data" data-index="e" data-fixed="0"
                                  data-end="31500">0</span>
                            EMPLOYEES
                        </p>
                    </div>

                </div>
                <div class="col large">

                    <div class="block-number">
                        <div class="block-number-icon icon-societaires"></div>
                        <p class="block-number-content">
                            <span class="red onscroll onscroll-data" data-index="f" data-fixed="0" data-end="12"
                                  data-suffix=" MILLION">0 </span>
                            MEMBERS AND CUSTOMERS

                        </p>
                    </div>

                </div>
            </div>

            <div class="row row-anchor">
                <div id="l-innovation-moteur-de-notre-croissance" class="anchor onscroll" data-step="2"></div>
                <div class="col small">
                    <h2 class="onscroll onscroll-title">
                        <span>INNOVATION</span>
                        <span>IS THE FUEL</span>
                        <span>THAT POWERS OUR GROWTH</span>
                    </h2>
                </div>
                <div class="col large">
                    <h3 class="onscroll onscroll-translate">
                        Groupama supports and encourages technological, social and insurance innovations that benefit
                        our stakeholders.<br>
                        These innovations are integral parts of our growth drivers and levers.

                    </h3>
                </div>
            </div>

            <div class="row row-panels">
                <a href="#" class="panel panel-red" :class="{'normal' : panel === null, 'active'  : panel === 0}" @click.prevent="selectPanel(0)">

                    <div class="panel-container">
                        <p class="panel-title">
                            DEVELOPING ARTIFICIAL INTELLIGENCE

                        </p>

                        <p class="panel-content">
                            In 2019, the POCAIMON (Process Optimization Conceived by Artificial Intelligence for MONey)
                            Group challenge that rewards innovative AI-enabled projects initiated within the Group
                            selected 3 winners from the 12 entries received.

                        </p>

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 60.98">
                            <polygon points="95 13.48 81.52 0 47.5 34.03 13.48 0 0 13.48 47.5 60.98 95 13.48"/>
                        </svg>


                    </div>

                </a>
                <a href="#" class="panel panel-blue" :class="{'normal' : panel === null, 'active'  : panel === 1 }"
                   @click.prevent="selectPanel(1)">
                    <div class="panel-container">
                        <p class="panel-title">
                            AUTOMATING PROCESSES
                        </p>

                        <p class="panel-content">
                            The closing months of 2019 saw the Italian, Romanian and Tunisian launch of the RPA (Robotic
                            Process Automation) project designed to facilitate the daily working lives of staff.

                        </p>

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 60.98">
                            <polygon points="95 13.48 81.52 0 47.5 34.03 13.48 0 0 13.48 47.5 60.98 95 13.48"/>
                        </svg>
                    </div>
                </a>
                <a href="#" class="panel panel-green" :class="{ 'normal' : panel === null, 'active'  : panel === 2}"
                   @click.prevent="selectPanel(2)">
                    <div class="panel-container">
                        <p class="panel-title">
                            PROMOTING INNOVATION IN PERSONAL SERVICES

                        </p>

                        <p class="panel-content">
                            The Groupama Live 2019 forum showcased 27 Group tech initiatives.

                        </p>

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 60.98">
                            <polygon points="95 13.48 81.52 0 47.5 34.03 13.48 0 0 13.48 47.5 60.98 95 13.48"/>
                        </svg>
                    </div>
                </a>
                <a href="#" class="panel panel-lightGreen" :class="{'normal' : panel === null, 'active'  : panel === 3}"
                   @click.prevent="selectPanel(3)">
                    <div class="panel-container">
                        <p class="panel-title">
                            HELPING MAYORS AND LOCAL COUNCILLORS

                        </p>

                        <p class="panel-content">
                            At the 2019 Salon des Maires procurement exhibition for mayors and local authorities,
                            Groupama showcased a comprehensive range of tools in its Mon Kit Elu one-stop digital
                            solution.
                        </p>

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 60.98">
                            <polygon points="95 13.48 81.52 0 47.5 34.03 13.48 0 0 13.48 47.5 60.98 95 13.48"/>
                        </svg>
                    </div>
                </a>
            </div>

            <div class="row row-anchor row-lowMargin">
                <div id="une-forte-presence-en-France-et-dans-le-monde" class="anchor onscroll" data-step="3"></div>
                <div class="col small">
                    <h2 class="onscroll onscroll-title">
                        <span>A STRONG PRESENCE</span>
                        <span>IN FRANCE </span>
                        <span>AND ABROAD</span>
                    </h2>
                </div>
                <div class="col large">
                    <h3 class="onscroll onscroll-translate">
                        Our extremely dense network coverage of France and our deep local roots bring us as close as
                        possible to all our customers and members.<br>
                    </h3>
                </div>
            </div>

            <div class="row row-lowMargin">
                <div class="col small">
                    <div class="map-container">
                        <div class="map"></div>
                        <p class="map-body">
                            <strong>Discover</strong> our presence in France
                        </p>
                        <a href="https://www.groupama.com/en/our-governance/the-group-organisation/local-and-regional-mutuals/"
                           target="_blank">
                            <svg class="map-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61">
                                <path d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                                      style="fill:#ffffff;stroke:#0b0b0b;stroke-miterlimit:10"/>
                                <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                                      style="fill:#0b0b0b"/>
                            </svg>
                        </a>

                    </div>
                </div>
                <div class="col large">
                    <h3 class="map-world-title onscroll onscroll-translate">OUR PRESENCE IN FRANCE</h3>

                    <div class="row row-map">

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 1</span>
                                PUBLIC AUTHORITIES

                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 2</span>
                                INDIVIDUAL PROTECTION INSURER

                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 1</span>
                                INDIVIDUAL HEALTH INSURER

                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 2</span>
                                HOME INSURER

                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 1</span>
                                AGRICULTURAL INSURER

                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 4</span>
                                MOTOR INSURER

                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row row-map-col-number">
                <div class="map-col-number">
                    <div class="map-col-number-icon icon-collaborateurs"></div>
                    <div class="map-col-number-body">
                        <span class="blue onscroll onscroll-data" data-index="g" data-fixed="0" data-end="25000"
                              data-suffix="">0</span>
                        EMPLOYEES
                    </div>
                </div>
                <div class="map-col-number">
                    <div class="map-col-number-icon icon-societaires"></div>
                    <div class="map-col-number-body">
                        <span class="red onscroll onscroll-data" data-index="h" data-fixed="1" data-end="6.5"
                              data-suffix=" Million">0 Million</span>
                        MEMBERS AND CUSTOMERS

                    </div>
                </div>
                <div class="map-col-number">
                    <div class="map-col-number-icon icon-chiffres"></div>
                    <div class="map-col-number-body">
                        <span class="green onscroll onscroll-data" data-index="i" data-fixed="1" data-end="11.9"
                              data-suffix=" Billion">0 Mds€</span>
                        IN PREMIUM INCOME
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col small">
                    <div class="map-container">
                        <div class="map map-world"></div>
                        <p class="map-body">
                            <strong>Discover</strong> our international presence
                        </p>
                        <a href="https://www.groupama.com/en/our-model/present-in-9-countries/" target="_blank">
                            <svg class="map-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61">
                                <path d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                                      style="fill:#ffffff;stroke:#0b0b0b;stroke-miterlimit:10"/>
                                <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                                      style="fill:#0b0b0b"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="col large">

                    <h3 class="onscroll onscroll-translate">
                        The Group occupies strong positions in the international markets that generate 17% of its
                        revenue.<br><br><br>
                    </h3>

                    <h3 class="map-world-title onscroll onscroll-translate">A PRESENCE IN 9 COUNTRIES
                        INTERNATIONALLY</h3>

                    <div class="row row-map">

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 1</span>
                                AGRICULTURAL INSURER IN ROMANIA


                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 4</span>
                                NON-LIFE INSURER IN HUNGARY

                            </p>
                        </div>


                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 2</span>
                                HOME INSURER IN HUNGARY

                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 7</span>
                                MOTOR INSURER IN TURKEY

                            </p>
                        </div>

                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 2</span>
                                FOREIGN NON-LIFE INSURER IN CHINA


                            </p>
                        </div>
                        <div class="map-number">
                            <p class="onscroll onscroll-translate">
                                <span>No. 8</span>
                                NON-LIFE INSURER IN ITALY

                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row row-map-col-number">
                <div class="map-col-number">
                    <div class="map-col-number-icon icon-collaborateurs"></div>
                    <div class="map-col-number-body">
                        <span class="blue onscroll onscroll-data" data-index="j" data-fixed="0" data-end="6500"
                              data-suffix="">0</span>
                        EMPLOYEES
                    </div>
                </div>
                <div class="map-col-number">
                    <div class="map-col-number-icon icon-societaires"></div>
                    <div class="map-col-number-body">
                        <span class="red onscroll onscroll-data" data-index="k" data-fixed="1" data-end="5.5"
                              data-suffix=" Million">0 Million</span>
                        CUSTOMERS
                    </div>
                </div>
                <div class="map-col-number">
                    <div class="map-col-number-icon icon-chiffres"></div>
                    <div class="map-col-number-body">
                        <span class="green onscroll onscroll-data" data-index="l" data-fixed="1" data-end="2.4"
                              data-suffix=" Billion">0 Billion </span>
                        IN PREMIUM INCOME
                    </div>
                </div>
            </div>

            <div class="row row-anchor row-lowMargin" style="justify-content: flex-start">
                <div id="les-instances-de-decision" class="anchor o" data-step="4"></div>
                <div>
                    <h2 class="onscroll onscroll-title">
                        <span>OUR DECISION-MAKING</span>
                        <span>BODIES</span>
                    </h2>
                </div>
            </div>

            <div class="row row-orga-gouv">
                <div class="col">
                    <h3 class="red uppercase extraBold">THE GROUP ORGANISATION</h3>
                    <div class="row row-orga row-lowMargin">
                        <div class="slider-mobile">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                                <path d="M0,30A30,30,0,1,0,30,0,30.09,30.09,0,0,0,0,30Zm58.1-.9H26.3l5.5-5.5V21l-9,9,9,9V36.4l-5.5-5.5H58.1a28.2,28.2,0,1,1,0-1.8Z"/>
                            </svg>
                        </div>
                        <div class="organisation organisation-1">
                            <div class="organisation-item organisation-item-1">
                                <div></div>
                                <p>LOCAL <span>MUTUALS</span> <span></span></p>
                            </div>
                            <div class="organisation-item organisation-item-1">
                                <div></div>
                                <p>REGIONAL <span>MUTUALS</span> <span></span></p>
                            </div>
                            <div class="organisation-item organisation-item-1">
                                <div></div>
                                <p>Groupama <span>Assurances</span><span>Mutuelles</span></p>
                            </div>
                        </div>
                        <div class="organisation organisation-2">
                            <div class="organisation-item organisation-item-2">
                                <p>FINANCIAL <span>SUBSIDIARIES</span> <span></span></p>
                            </div>
                            <div class="organisation-item organisation-item-2">
                                <p>Groupama
                                    <span>HOLDING</span><span> SUBSIDIARIES </span><span>AND EQUITY INTERESTS</span></p>
                            </div>
                            <div class="organisation-item organisation-item-2">
                            </div>
                        </div>
                        <div class="organisation organisation-3">
                            <div class="organisation-item organisation-item-3">
                                <p>INSURANCE <span>SUBSIDIARIES </span><span>France</span></p>
                            </div>
                            <div class="organisation-item organisation-item-3">
                                <p>SERVICE <span>SUBSIDIARIES </span><span>France</span></p>
                            </div>
                            <div class="organisation-item organisation-item-3">
                                <p>INTERNATIONAL <span>SUBSIDIARIES</span></p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col">
                    <h3 class="red uppercase extraBold">OUR GOVERNANCE</h3>
                    <div class="gouvernance">
                        <a href="https://www.groupama.com/en/our-governance/decision-making-bodies/groupama-assurances-mutuelles-board-of-directors/"
                           target="_blank" class="gouvernance-item">
                            <p class="gouvernance-title">
                                GROUPAMA ASSURANCES <br>MUTUELLES BOARD <br>OF DIRECTORS
                            </p>
                            <svg class="gouvernance-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61">
                                <path d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                                      style="fill:#ffffff;stroke:#0b0b0b;stroke-miterlimit:10"/>
                                <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                                      style="fill:#0b0b0b"/>
                            </svg>
                        </a>
                        <a href="https://www.groupama.com/en/our-governance/decision-making-bodies/the-mutualist-orientation-council/"
                           target="_blank" class="gouvernance-item">
                            <p class="gouvernance-title">
                                THE MUTUALIST <br> ORIENTATION COUNCIL
                            </p>
                            <svg class="gouvernance-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61">
                                <path d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                                      style="fill:#ffffff;stroke:#0b0b0b;stroke-miterlimit:10"/>
                                <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                                      style="fill:#0b0b0b"/>
                            </svg>
                        </a>
                        <a href="https://www.groupama.com/en/our-governance/decision-making-bodies/group-executive-committee/"
                           target="_blank" class="gouvernance-item">
                            <p class="gouvernance-title">
                                GROUP <br> EXECUTIVE COMMITTEE
                            </p>
                            <svg class="gouvernance-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61">
                                <path d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                                      style="fill:#ffffff;stroke:#0b0b0b;stroke-miterlimit:10"/>
                                <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                                      style="fill:#0b0b0b"/>
                            </svg>
                        </a>
                        <!--
                        <a href="https://www.groupama.com/fr/notre-gouvernance/instances-executives/comite-de-direction-generale/"
                           target="_blank" class="gouvernance-item">
                            <p class="gouvernance-title">
                                STEERING <br> COMITTEE
                            </p>
                            <svg class="gouvernance-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61">
                                <path d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                                      style="fill:#ffffff;stroke:#0b0b0b;stroke-miterlimit:10"/>
                                <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                                      style="fill:#0b0b0b"/>
                            </svg>
                        </a>
                        -->
                    </div>
                </div>
            </div>


            <div class="row row-anchor row-lowMargin" style="justify-content: flex-start">
                <div id="les-indicateurs-rse" class="anchor o" data-step="5"></div>
                <div>
                    <h2 class="onscroll onscroll-title">
                        <span>OUR CSR INDICATORS</span>
                    </h2>
                </div>
            </div>

            <h3 class="onscroll onscroll-translate">
                Our mutualist organisational structure has always put people at the centre of all the company's actions
                and concerns. Having remained faithful to this belief and our mutualist operating principles for more
                than 100 years, the Group remains committed to addressing social, societal and environmental issues
                through the way it does business and the way it interacts with its stakeholders.
            </h3>

            <div class="row rse" style="margin-top: 80px">
                <div class="rse-item">
                    <img class="rse-item-image" :src="require('./../assets/icon-rh.svg')" width="93" height="60">
                    <div class="rse-item-title">HR</div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>GENDER PARITY</span>

                        </div>
                        <div class="rse-item-number">
                            48%
                        </div>
                        <p class="rse-item-body">OF WOMEN AMONG <br> EXECUTIVES</p>
                    </div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>DISABLED EMPLOYEESs</span>
                        </div>
                        <div class="rse-item-number">
                            3.6%
                        </div>
                        <p class="rse-item-body">
                            OF THE TOTAL FULL-TIME WORKFORCE HAVE DISABILITIES

                        </p>
                        <div class="rse-item-label">
                            <span>APPRENTICES</span>
                        </div>
                        <div class="rse-item-number">
                            879
                        </div>
                        <p class="rse-item-body">
                            APPRENTICES
                            <span>CONVERSION RATE OF WORK-STUDY APPRENTICES TO FULL-TIME POSITIONS: 30%</span>
                        </p>
                    </div>
                </div>
                <div class="rse-item">
                    <img class="rse-item-image" :src="require('./../assets/icon-societaux.svg')" width="60" height="60">
                    <div class="rse-item-title">SOCIAL</div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>CORPORATE SPONSORSHIP</span>
                        </div>
                        <div class="rse-item-number">
                            €7m
                        </div>
                        <p class="rse-item-body">
                            INVESTED IN CORPORATE SPONSORSHIP, INCLUDING THE FIGHT AGAINST RARE DISEASES

                        </p>
                    </div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>SAFETY AND PREVENTION</span>
                        </div>
                        <div class="rse-item-number">
                            139,000
                        </div>
                        <p class="rse-item-body">
                            PEOPLE RECEIVED ACCIDENT PREVENTION AWARENESS TRAINING
                        </p>
                        <div class="rse-item-number">
                            18,920
                        </div>
                        <p class="rse-item-body">
                            TRAINEES COMPLETED ECO-DRIVING MODULES IN CENTAURE CENTRES
                        </p>
                    </div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>RESPONSIBLE</span>
                            <span>INVESTMENTS</span>
                        </div>
                        <div class="rse-item-number">
                            €76.1 billion
                        </div>
                        <p class="rse-item-body">
                            AUM BY GROUPAMA ASSET MANAGEMENT INVESTED IN SRI
                        </p>
                    </div>
                </div>
                <div class="rse-item">
                    <img class="rse-item-image" :src="require('./../assets/icon-environnementaux.svg')" height="60"
                         width="60">
                    <div class="rse-item-title">ENVIRONMENTAL</div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>Paper</span>
                        </div>
                        <div class="rse-item-number">
                            7.1%
                        </div>
                        <p class="rse-item-body">
                            LESS PAPER USED THAN IN 2018

                        </p>
                    </div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>CO<sub>2</sub></span>
                        </div>
                        <div class="rse-item-number">
                            7.4%
                        </div>
                        <p class="rse-item-body">
                            LOWER CO<sub>2</sub> EMISSIONS THAN IN 2018
                        </p>
                        <div class="rse-item-number">
                            10
                        </div>
                        <p class="rse-item-body">
                            MILLION TONNES CO<sub>2</sub> CAPTURED AND STORED IN FORESTS OWNED BY GROUPAMA
                        </p>
                    </div>
                    <div class="rse-item-box">
                        <div class="rse-item-label">
                            <span>ENERGY</span>
                        </div>
                        <div class="rse-item-number">
                            19%
                        </div>
                        <p class="rse-item-body">
                            FALL IN ENERGY CONSUMPTION SINCE 2013 (ELECTRICITY, GAS, FUEL OIL AND OTHER ENERGY SOURCES)

                        </p>
                        <p class="rse-item-ml">
                            Group data at 31.12.2019
                        </p>
                    </div>
                </div>
            </div>
            <div class="rse">
                <div class="rse-item"></div>
                <div class="rse-item">
                    <div class="rse-item-box">
                        <strong>Discover</strong> the detail<br>
                        of the Group's CSR indicators <a
                            href="https://www.groupama.com/en/our-commitment/group-csr-indicators/"
                            target="_blank">
                        <svg class="rse-item-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.61 53.61">
                            <path d="M26.8.5A26.31,26.31,0,1,1,.5,26.8,26.31,26.31,0,0,1,26.8.5Z"
                                  style="fill:#ffffff;stroke:#0b0b0b;stroke-miterlimit:10"/>
                            <path d="M32.26,16.06a1.11,1.11,0,0,0-1.58,0,1.13,1.13,0,0,0,0,1.58l8,8H12.17a1.12,1.12,0,0,0,0,2.24H38.72l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"
                                  style="fill:#0b0b0b"/>
                        </svg>
                    </a>
                    </div>
                </div>
                <div class="rse-item"></div>
            </div>
            <a href="#top" class="scrollTop" @click.prevent="goTo($event)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 55">
                    <polygon points="95 47.5 47.5 0 0 47.5 7.6 55 47.5 15.1 87.4 55 95 47.5"/>
                </svg>
            </a>

        </div>
        <div class="rse-deco-container">
            <div class="rse-deco"></div>
        </div>

    </main>

</template>

<script>

    import anime from 'animejs'

    export default {
        name: "RaisonEtre",
        data() {
            return {
                ww: null,
                panel: null,
                scrolled: false,
                a: {value: 0},
                b: {value: 0},
                c: {value: 0},
                d: {value: 0},
                e: {value: 0},
                f: {value: 0},
                g: {value: 0},
                h: {value: 0},
                i: {value: 0},
                j: {value: 0},
                k: {value: 0},
                l: {value: 0},
                observer: null,
                step: null,
                anchors: [],
            }
        },
        mounted() {

            let config = {
                rootMargin: '-100px',
                threshold: .5
            };

            this.observer = new IntersectionObserver(this.onIntersection, config);
            let elem = document.querySelectorAll('.onscroll');

            for (let i = 0; i < elem.length; i++)
                this.observer.observe(elem[i]);

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)
            window.removeEventListener('resize', this.resize)
            window.addEventListener('resize', this.resize)
            this.resize();


            document.querySelector('.background').style.width = document.querySelector('.col.large').getBoundingClientRect().left - 50 + 'px'
            document.querySelector('.background').style.left = -document.querySelector('.background').getBoundingClientRect().left + 'px'

            let anchor = document.querySelectorAll('.anchor');

            for (let i = 0; i < anchor.length; i++) {
                this.anchors.push(anchor[i].getBoundingClientRect().top + 100)
            }

        },
        methods: {
            resize() {
              this.ww = window.innerWidth;
            },
            onIntersection(entries) {

                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        if (entry.target.classList.contains('onscroll-title') && window.innerWidth > 500) {

                            anime({
                                targets: entry.target.querySelectorAll('span'),
                                scaleY: [0, 1],
                                opacity: [0, 1],
                                delay: anime.stagger(100),
                                easing: 'easeInOutQuad',
                                duration: 300
                            })

                        } else if (entry.target.classList.contains('onscroll-data')) {
                            let data = entry.target.dataset;
                            let index = data.index;
                            let fixed = data.fixed;
                            let end = data.end;
                            let suffix = data.suffix ? data.suffix : '';

                            anime({
                                targets: this[index],
                                value: end,
                                easing: 'linear',
                                update: () => {
                                    entry.target.innerHTML = parseFloat(this[index].value)
                                        .toFixed(fixed)
                                        .toString()
                                        //.replace('.', ',')
                                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + suffix;
                                }
                            });
                        } else if (entry.target.classList.contains('onscroll-translate') && window.innerWidth > 500) {

                            anime({
                                targets: entry.target,
                                translateY: ['-20px', 0],
                                opacity: [0, 1],
                                easing: 'easeInOutQuad',
                            })

                        } else if (entry.target.classList.contains('anchor')) {
                            this.step = parseInt(entry.target.dataset.step);
                            return;
                        }

                        this.observer.unobserve(entry.target);
                    }
                })
            },
            enter(el, done) {
                anime({
                    easing: 'easeInOutQuad',
                    targets: el,
                    duration: 300,
                    translateY: ['-100%', 0],
                    complete: () => {
                        done();
                    }
                })

            },
            leave(el, done) {
                anime({
                    easing: 'easeInOutQuad',
                    targets: el,
                    duration: 300,
                    translateY: [0, '-100%'],
                    complete: () => {
                        done();
                    }
                })
            },
            scroll() {
                if (document.querySelector('.header').getBoundingClientRect().bottom <= 100)
                    this.scrolled = true;
                else
                    this.scrolled = false;


                for (let i = 0; i < this.anchors.length; i++) {

                    if (window.pageYOffset > this.anchors[i])
                        this.step = i + 1;
                }


            },
            selectPanel(index) {
                this.panel = this.panel === index ? null : index;
            },
            goTo(event) {
                let id = event.currentTarget.getAttribute('href');

                if (id === '#top') {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                    return;
                }

                document.querySelector(id).scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }
</script>

<style scoped lang="scss">

    $blue: #2BA5D3;
    $green: #A1BF38;
    $magenta: #C41E4A;
    $yellow: #ECBF3E;
    $green1: rgb(28, 105, 85);
    $violet: #7d3181;

    .onscroll-translate {
        opacity: 0;

        @media screen and (max-width: 500px) {
            opacity: 1;
        }

    }

    .menu-scroll {
        position: fixed;
        top: 0;
        background: white;
        padding: 20px;
        z-index: 99;
        left: 0;
        right: 220px;
        border-bottom: 1px solid rgba(0, 0, 0, .1);

        &-container {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
            margin: auto;
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            justify-content: space-between;
        }

        &-item {
            display: flex;
            align-items: flex-start;
            text-decoration: none;
            color: $green1;
            text-transform: uppercase;
            font-weight: 700;
            transition: .25s ease;
            opacity: .5;

            &.active {
                opacity: 1;
            }

            &:hover {
                transform: translateX(10px);
            }

            svg {
                width: 10px;
                height: 20px;
                margin-right: 10px;
                fill: $yellow;
            }
        }

    }

    .page-raison-etre {
        display: flex;
        flex-direction: column;
        padding-right: 220px;
        margin-top: 50px;
        background: white;


        .container {
            padding: 50px;
            max-width: 1120px;
            margin: auto;
            width: 100%;

            @media screen and (max-width: 1180px) {
                max-width: 100%;
            }

        }

        .header {
            background: white;
            width: 100%;
            margin-bottom: 80px;
            position: relative;
            z-index: 2;

            img {
                max-width: 100%;
                height: auto;
                display: block;
            }

            &-list {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                display: flex;
                flex-direction: column;
            }

            &-item {
                align-self: flex-end;
                text-align: right;
                color: $green1;
                font-size: 18px;
                font-weight: 700;
                text-decoration: none;
                text-transform: uppercase;
                margin-bottom: 25px;
                line-height: 20px;
                display: flex;
                align-items: center;
                transition: .25s ease;

                &:hover {
                    padding-right: 20px;

                    color: #00352c;

                }


                span {
                    margin-right: 30px;
                }

                svg {
                    width: 19px;
                    height: 29px;
                    fill: $yellow;
                }

                &:last-child {
                    margin-bottom: 0;
                }

            }

        }

        .row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 120px;

            &:last-child {
                margin-bottom: 0;
            }

            &-block {
                margin-left: -3px;
                margin-right: -3px;
                margin-bottom: 6px;
                flex-wrap: wrap;
            }

            &-panels {
                margin-left: -10px;
                margin-right: -10px;
                flex-wrap: wrap;
                justify-content: center;
                position: relative;
            }

            &-lowMargin {
                margin-bottom: 10px;
            }

            &-map {
                margin-bottom: 0;
                flex-wrap: wrap;
            }

            &-map-col-number {
                margin-top: 50px;
            }

            &-orga {
                max-width: 620px;
            }

        }

        .col {
            position: relative;


            &.small {
                width: calc(100% / 8 * 3);
            }

            &.large {
                width: calc(100% / 8 * 4);
                background: white;
            }

            .background {
                background-color: #f8f7f5;
                position: absolute;
                left: 0;
                top: -170px;
                bottom: 0;
            }

            .content {
                position: relative;
                z-index: 2;
                padding-right: 45px;
                padding-bottom: 45px;
                padding-top: 170px;
                margin-top: -170px;
                display: flex;
                flex-direction: column;
            }

        }

        p {
            font-size: 16px;
            line-height: 21px;
            color: #0b0b0b;
            font-weight: 400;

            &.extraBold {
                font-weight: 900;
            }

            &.uppercase {
                text-transform: uppercase;
            }
        }

        h2 {
            display: flex;
            flex-direction: column;

            span {
                opacity: 0;
            }

            span {
                background: $green1;
                color: white;
                text-transform: uppercase;
                font-size: 23px;
                line-height: 25px;
                font-weight: 700;
                padding: 2px 5px 0;
                align-self: flex-start;
            }
        }

        h3 {
            font-size: 18px;
            line-height: 22px;
            color: $green1;
            font-weight: 600;

            &.red {
                color: $magenta;
            }

            &.extraBold {
                font-weight: 900;
            }

            &.uppercase {
                text-transform: uppercase;
            }

            + p {
                margin-bottom: 40px;
            }

        }


        .client {
            margin-top: 20px;
            margin-bottom: 20px;

            &-logo {
                img {

                    &.groupama {
                        width: 139px;
                        height: 37px;
                    }

                    &.gan {
                        width: 48px;
                        height: 48px;
                    }

                    &.amaguiz {
                        width: 144px;
                        height: 34px;
                    }

                }
            }

            &-body {
                font-weight: 600;
                font-size: 16px;
                line-height: 18px;
            }

            &-link {
                text-decoration: none;
                font-size: 16px;
                line-height: 18px;
                color: $green1;
                font-weight: 700;
                margin-top: 5px;
                position: relative;
                padding: 2px;
                display: inline-block;

                span {
                    position: relative;
                    z-index: 2;
                }

                &::before {
                    content: attr(data-link);
                    background: $green;
                    font-size: 16px;
                    line-height: 18px;
                    width: 0%;
                    font-weight: 700;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    position: absolute;
                    transition: .25s ease;
                    overflow: hidden;
                    color: white;
                    z-index: 4;
                    display: flex;
                    align-items: center;
                    text-indent: 2px;

                }

                &:hover::before {
                    width: 100%;
                }

            }
        }

        .block {
            margin-left: 3px;
            margin-right: 3px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;

            &:last-child {
                .block-image {
                    transform: translateY(12px);
                }
            }

            > div {
                padding: 17px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            &-image {
                height: 80px !important;
                padding: 0!important;
                max-width: 100%;
                display: block !important;
                margin-bottom: 0;
                margin-top: auto;
            }

            img {
                max-width: 100%;
                height: 100%;
                margin-left: auto;
                margin-right: auto;
                display: block !important;
                margin-bottom: 0;
                margin-top: auto;
            }


            p {
                color: white;
                text-align: center;
                text-transform: uppercase;
                font-weight: 700;
                font-size: 14px;
                line-height: 1.2;
                margin: 0;

                span {
                    display: block;
                    font-size: 40px;
                    margin-top: 30px;
                }
            }

            &-blue {
                background-color: $blue;
            }

            &-red {
                background-color: $magenta;
            }

            &-yellow {
                background-color: $yellow;
            }

            &-green {
                background-color: $green1;
                margin-left: -3px;
                margin-right: -3px;

                p {
                    span {
                        margin-top: 0;
                        text-transform: none;
                    }
                }
            }
        }


        .block-number {
            display: flex;
            align-items: center;

            &-icon {
                margin-right: 20px;
            }

            &-content {

                color: $green1;
                font-weight: 700;
                text-transform: uppercase;
                font-size: 16px;
                line-height: 1.2;

                span {
                    display: block;
                    font-size: 40px;
                    font-weight: 900;

                    &.blue {
                        color: $blue;
                    }

                    &.red {
                        color: $magenta;
                    }


                }
            }
        }


        .panel {

            text-decoration: none;
            width: calc(50% - 10px);
            margin-left: 10px;
            margin-bottom: 10px;
            padding: 30px;
            cursor: pointer;
            transition: .25s box-shadow ease, .25s transform ease, .25s background-color ease;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0);

            opacity: 0;

            &.normal {
                opacity: 1;
            }

            &:hover {
                transform: scale(1.01);
                box-shadow: 0 0 20px rgba(0, 0, 0, .1);

                &.panel-blue {
                    background-color: #008cb9;
                }

                &.panel-red {
                    background-color: #821432;
                }

                &.panel-green {
                    background-color: #005542;
                }

                &.panel-lightGreen {
                    background-color: #85a540;
                }

            }

            &.active {
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                z-index: 9;
                transition: none;
                transform: none !important;
                box-shadow: none;
                opacity: 1;

                &.panel-blue {
                    background-color: $blue !important;
                }

                &.panel-red {
                    background-color: $magenta !important;
                }

                &.panel-green {
                    background-color: $green1 !important;
                }

                &.panel-lightGreen {
                    background-color: $green !important;
                }


                .panel {
                    &-content {
                        display: block;
                    }

                    &-title {
                        font-size: 22px;
                    }

                    &-container {
                        svg {
                            top: 30px;
                            transform: translateY(0) rotate(180deg);
                        }
                    }
                }

            }

            &-blue {
                background-color: $blue;
            }

            &-red {
                background-color: $magenta;
            }

            &-green {
                background-color: $green1;
            }

            &-lightGreen {
                background-color: $green;
            }


            &-title {
                color: white;
                text-transform: uppercase;
                font-size: 16px;
                line-height: 1.2;
                font-weight: 700;
                padding-right: 150px;
                user-select: none;
            }

            &-content {
                font-size: 22px;
                line-height: 1.2;
                font-weight: 500;
                color: white;
                padding-right: 30px;
                display: none;
                user-select: none;
            }

            &-container {
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                position: relative;

                svg {
                    width: 29px;
                    height: 18px;
                    fill: $yellow;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }

        .map {
            background: url('../assets/map.svg') center center no-repeat;
            width: 236px;
            height: 257px;


            &-world {
                background-image: url('../assets/world.svg');
                width: 302px;
                height: 278px;

                &-title {
                    color: $magenta;
                    font-size: 24px;
                    line-height: 32px;
                    font-weight: 900;
                    text-transform: uppercase;
                    margin-top: 0;
                }

            }

            &-container {
                display: flex;
                flex-direction: column;
            }

            &-body {
                margin-left: 40px;
                padding-right: 40px;
                font-weight: 500;
                margin-top: 30px;
                margin-bottom: 20px;
            }

            &-link {
                width: 40px;
                height: 40px;
                cursor: pointer;
                margin-left: 40px;
                transition: .25s ease;
                border-radius: 50%;

                &:hover {
                    transform: scale(1.3) translateX(10px);
                    //   box-shadow: -5px 0 5px rgba(0, 0, 0, .2);

                    path:first-child {
                        fill: #0b0b0b !important;
                    }

                    path:last-child {
                        fill: white !important;
                    }
                }
            }

            &-number {
                width: 50%;
                padding-right: 10%;

                p {
                    text-transform: uppercase;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 1.2;
                    color: $green1;

                    span {
                        display: block;
                        color: $yellow;
                        font-size: 40px;
                        font-weight: 900;

                        sup {
                            text-transform: lowercase;
                            font-size: 60%
                        }

                    }
                }

            }

            &-col-number {
                display: flex;
                flex-direction: column;

                &-icon {
                    margin-bottom: 20px;
                }

                &-body {
                    text-transform: uppercase;
                    text-align: center;
                    max-width: 240px;
                    color: $green1;
                    font-size: 16px;
                    font-weight: 700;

                    span {
                        text-transform: none;
                        display: block;
                        font-weight: 900;
                        font-size: 40px;

                        &.blue {
                            color: $blue;
                        }

                        &.red {
                            color: $magenta;
                        }

                        &.green {
                            color: $green;
                        }
                    }
                }

            }
        }

        .organisation {
            position: relative;
            margin-right: 75px;
            display: flex;
            flex-direction: column;

            &-1 {
                .organisation-item {
                    &:last-child {
                        div {
                            transform: translateY(20px);
                        }
                    }

                    div {
                        background: url('../assets/avatar.svg') center center no-repeat;
                        width: 61px;
                        height: 43px;
                        margin-right: 10px;
                        transform: translateY(10px);
                    }
                }

                &::after {
                    content: '';
                    position: absolute;
                    width: 1px;
                    background: $green1;
                    right: calc(-75px / 2);
                    top: 43px;
                    bottom: 43px;
                    transform: translate(50%, 0);
                }
            }

            &-2 {
                &::after {
                    content: '';
                    position: absolute;
                    width: 1px;
                    background: $green1;
                    right: calc(-75px / 2);
                    top: 43px;
                    bottom: 43px;
                    transform: translate(50%, 0);
                }
            }

            &-3 {
            }


            &:last-child {
                margin-right: 0;
            }

            &-item {
                position: relative;

                &:last-child {
                    margin-bottom: 0;
                }

                p {
                    color: $green1;
                    text-transform: uppercase;

                    span {
                        display: block;
                        font-weight: bold;
                        height: 18px;
                    }
                }

                &-1 {
                    display: flex;

                    &:last-child {
                        &::after {
                            content: '';
                            position: absolute;
                            width: 21px;
                            height: 1px;
                            background: $green1;
                            right: calc(-75px / 2);
                            top: 50%;
                            transform: translate(0, -50%);
                        }
                    }
                }

                &-2 {
                    &:nth-child(1) {
                        &::before {
                            content: '';
                            position: absolute;
                            width: 20px;
                            height: 1px;
                            background: $green1;
                            left: calc(-75px / 2);
                            top: 50%;
                            transform: translate(0, -50%);
                        }
                    }

                    &:nth-child(2) {
                        &::before {
                            content: '';
                            position: absolute;
                            width: 20px;
                            height: 1px;
                            background: $green1;
                            left: calc(-75px / 2);
                            top: 50%;
                            transform: translate(0, -50%);
                        }

                        &::after {
                            content: '';
                            position: absolute;
                            width: 20px;
                            height: 1px;
                            background: $green1;
                            right: calc(-75px / 2);
                            top: 50%;
                            transform: translate(0, -50%);
                        }
                    }

                }

                &-3 {
                    &::after {
                        content: '';
                        position: absolute;
                        width: 21px;
                        height: 1px;
                        background: $green1;
                        left: calc(-75px / 2);
                        top: 50%;
                        transform: translate(0, -50%);
                    }
                }
            }
        }


        .gouvernance {
            display: flex;
            flex-direction: column;

            &-item {
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: pointer;
                text-decoration: none;

                &:hover {
                    .gouvernance {
                        &-link {
                            transform: scale(1.3) translateX(10px);
                            //  box-shadow: -5px 0 5px rgba(0, 0, 0, .2);

                            path:first-child {
                                fill: #0b0b0b !important;
                            }

                            path:last-child {
                                fill: white !important;
                            }
                        }
                    }
                }

            }


            &-title {
                margin-top: 0;
                margin-bottom: 0;
                font-size: 16px;
                line-height: 20px;
                font-weight: 600;
                text-transform: uppercase;
            }

            &-link {
                width: 40px;
                height: 40px;
                cursor: pointer;
                margin-left: 20px;
                transition: .25s ease;
                border-radius: 50%;

                path {
                    transition: .25s ease;
                }

            }
        }

        .anchor {
            position: absolute;
            top: -100px;

            @media screen and (max-width: 768px) {
                top: -250px;
            }

        }

        .row-anchor {
            position: relative;
            margin-bottom: 30px;
        }

        .scrollTop {
            background: #004135;
            border-radius: 50%;
            width: 52px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: auto;

            svg {
                fill: white;
                width: 19px;
                height: 11px;
            }
        }

        .icon {
            &-societaires {
                background: url('../assets/societaires.svg') center center no-repeat;
                min-width: 69px;
                height: 60px;
            }

            &-collaborateurs {
                background: url('../assets/collaborateurs.svg') center center no-repeat;
                min-width: 60px;
                height: 60px;
            }

            &-chiffres {
                background: url('../assets/chiffre.svg') center center no-repeat;
                min-width: 65px;
                height: 65px;
            }

        }

    }

    @media screen and (max-width: 1450px) {

        .row-orga-gouv {
            flex-direction: column;


            .col:last-child {
                margin-top: 40px;
            }
        }

        .menu-scroll-item {
            font-size: 12px;

            svg {
                height: 15px;
            }
        }


        .page-raison-etre {


            h2 span {
                align-self: center;
            }

            .map-world, .map {
                display: block;
                margin: auto;
            }

            .map-body {
                text-align: center;
            }

            .map-link {
                margin: auto;
            }
        }

    }

    @media screen and (max-width: 1220px) {

        .menu-scroll-item {
            font-size: 10px;

            svg {
                height: 12px;
            }
        }
    }

    @media screen and (max-width: 780px) {

        .menu-scroll {
            right: 0;
            border-top: 1px solid rgba(0, 0, 0, .1);
            text-align: left;
            top: 90px;

            &-item {
                padding: 5px;
                font-size: 12px;
                width: 100%;

                br {
                    display: none;
                }

                svg {
                    display: none;
                }

            }

            &-container {
                justify-content: center;
                flex-direction: column;
            }
        }

        .page-raison-etre {
            padding-right: 0;
            margin-top: 50px;

            .header {
                margin-bottom: 30px;
            }

            .header-item {
                font-size: 15px;
                line-height: 17px;
                text-align: center;
            }

            .col {


                .content {
                    margin-top: 0;
                    padding-top: 0;
                }

                &.small, &.large {
                    width: 100%;
                }
            }

            .block {
                margin-bottom: 30px;

            }

            .panel {
                width: 100%;
                margin-left: 0;

                &-title {
                    padding-right: 40px;
                }

                &.active {
                    bottom: auto;
                }

            }

            .header-list {
                position: static;
                transform: none;
                margin-top: 20px;
            }


            .row {
                margin-bottom: 40px;
                flex-direction: column;

                &-anchor {
                    position: relative;
                    justify-content: flex-start;
                }

                &-block {
                    margin-bottom: 6px;
                }

                &-map {
                    flex-direction: row;
                    justify-content: center;
                    text-align: center;
                    align-items: center;
                }

                &-orga {
                    flex-direction: row;
                    overflow: auto;
                    white-space: nowrap;
                }
            }

            .map {
                &-world-title {
                    margin-top: 40px;
                }

                &-number {
                    padding-right: 10px;
                }

                &-col-number {
                    &-body {
                        margin: 0 auto 40px;
                    }
                }
            }

            .container {
                padding: 25px;
                max-width: 100%;
                margin: auto;
            }
        }

        .page-raison-etre h2 span {
            font-size: 24px;
            line-height: 26px;
        }
    }

    @media screen and (max-width: 480px) {
        .page-raison-etre .map-world {
            max-width: 100%;
        }
    }

    @media screen and (max-width: 780px) {
        .page-raison-etre .map-container a {
            text-align: center;
        }

        .page-raison-etre .gouvernance-item {
            justify-content: flex-start;
        }
    }

    @media screen and (max-width: 500px) {


        .page-raison-etre .map-number p {
            font-size: 13px;
        }

        .page-raison-etre h2 span {
            opacity: 1;
            font-size: 20px;
            line-height: 22px;
        }

        .page-raison-etre .block-number-content span {
            font-size: 20px;
        }

        .menu-scroll {
            display: none;
        }

        .page-raison-etre h3 {
            font-size: 18px;
            line-height: 22px;
        }
    }

    .rse {
        display: flex;
        flex-wrap: wrap;
        margin-left: -40px;
        margin-right: -40px;
        justify-content: flex-end !important;
        margin-bottom: 20px !important;
        position: relative;

        &-deco {
            background: url(../assets/deco.png) left center no-repeat;
            background-size: contain;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100vh;
            user-select: none;
            pointer-events: none;

            &-container {
                position: relative;
            }
        }

        &.row {
            margin-bottom: 20px !important;
        }

        &-item {
            width: calc(100% / 3);
            padding-left: 40px;
            padding-right: 40px;
            position: relative;

            &-button {
                width: 30px;
                height: 30px;
                position: absolute;
                transform: translateX(10px) translateY(-5px);
                transition: .25s ease;

                path {
                    transition: .25s ease;
                }

                &:hover {
                    transform: scale(1.3) translateX(10px) translateY(-5px);

                    path {

                        &:first-child {
                            fill: black !important;
                        }

                        &:last-child {
                            fill: white !important;
                        }
                    }

                }

            }

            &-ml {
                color: $violet !important;
                font-size: 14px !important;
                font-weight: 400 !important;
            }

            &-image {
                max-height: 60px;
                margin-bottom: 20px;
            }

            &-title {
                color: $violet;
                text-transform: uppercase;
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 30px;
            }

            &-label {
                display: flex;
                flex-direction: column;
                margin-bottom: 15px;

                span {
                    background: $violet;
                    color: white;
                    padding: 2px;
                    align-self: flex-start;
                    text-transform: uppercase;
                    font-size: 16px;
                    font-weight: bold;
                }
            }

            &-number {
                font-size: 40px;
                font-weight: 900;
                color: $violet;
                margin-bottom: 0;
                line-height: 1.3;
                position: relative;

                sup {
                    line-height: 0;
                }
            }

            &-body {
                margin-top: 0;
                font-weight: 600 !important;
                font-size: 14px !important;
                text-transform: uppercase;
                margin-bottom: 40px;

                sup, sub {
                    line-height: 0;
                }

                span {
                    display: block;
                    font-weight: 100 !important;
                }
            }
        }
    }

    @media screen and (max-width: 1400px) {


        .rse {
            &-item {
                &-title {
                    font-size: 20px;
                }

                &-number {
                    font-size: 30px;
                }
            }
        }

    }


    @media screen and (max-width: 780px) {


        .rse {
            flex-direction: column !important;
            justify-content: center !important;
            margin-left: 0;
            margin-right: 0;

            &-deco-container {
                display: none;
            }

            &-item {
                width: 100% !important;
                text-align: center;
                margin: 0 auto 30px;

                &-image {
                    margin-bottom: 10px;
                }

                &-label {
                    span {
                        align-self: center !important;
                    }
                }

            }
        }
    }


    .slider-mobile {
        display: none;
    }

    @media screen and (max-width: 600px) {
        .page-raison-etre {

            h2 span {
                align-self: flex-start;
            }

            .icon-societaires, .icon-collaborateurs, .icon-chiffres {
                min-width: 70px !important;
            }

            .panel-content {
                font-size: 16px;
            }

            .panel.active {
                .panel-title {
                    font-size: 16px;
                }
            }
        }
    }

    @media screen and (max-width: 500px) {

        .row.rse {
            margin-bottom: 0 !important;
        }

        .slider-mobile {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            svg {
                width: 30px;
                height: 30px;
                margin-right: 10px;
                transform: scale(-1, 1);
                animation: 1s ease ltr infinite alternate;
                opacity: .4;
            }

        }

        @keyframes ltr {
            0% {
                transform: translateX(10px) scale(-1, 1);
            }

            100% {
                transform: translateX(-10px) scale(-1, 1);
            }
        }


    }

</style>
